import { useTheme } from "@emotion/react";
import { Box, createTheme, ThemeProvider, Typography } from "@mui/material";
import MUIDataTable from "mui-datatables";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import {
  DataTableTheme,
  subTitleStyle,
  titleTwoStyles,
  typeColor
} from "./DataTable.Styles";

const DataTable = ({
  columns,
  options,
  data,
  components,
  searchResultsCount,
  noRecord,
  showTitle = true,
  ...props
}) => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const globalTheme = useTheme();
  const intergratedDataTableTheme = createTheme(globalTheme, DataTableTheme);

  const title = !noRecord
    ? searchResultsCount > 1
      ? `${searchResultsCount} ${t("common.recordsFound")}`
      : `${searchResultsCount} ${t("common.recordFound")}`
    : undefined;

  const commonOptions = {
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    scroll: "vertical"
  };

  const combinedOptions = { ...commonOptions, ...options };

  const titleComponent = title && Boolean(searchResultsCount) && (
    <div style={subTitleStyle}>
      <Typography style={typeColor}>{title}</Typography>
      {state?.highpriority && (
        <Typography style={titleTwoStyles} variant="subtitle1">
          {t("dashboard.tODORequestsNotCompleted")}
        </Typography>
      )}
    </div>
  );

  return (
    <ThemeProvider theme={intergratedDataTableTheme}>
      <Box>
        <MUIDataTable
          title={showTitle ? titleComponent : ""}
          options={combinedOptions}
          {...props}
          {...{ data, columns, components }}
          responsive="scrollFullHeight"
        />
      </Box>
    </ThemeProvider>
  );
};

export default DataTable;
